'use client';

import type { SmallImageTextProps } from '@/core/types';

import React from 'react';

import { Box, Image, Button, Container, Typography } from '@/components/ui';

import { RouterLink } from '@/routes/components';

export default function SmallImageText({
  title,
  description,
  image,
  buttons,
  className = '',
  infoClasses = '',
  contentClasses = '',
  imageClasses = '',
}: SmallImageTextProps) {
  const isReverse = className.includes('col-reverse');
  return (
    <Box component="section" className={`relative bg-light-gray/56 py-8 md:py-24 ${className}`}>
      <Container>
        <Box
          className={`flex flex-col ${isReverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-6 md:gap-10 items-center ${contentClasses}`}
        >
          <Box className={`w-full lg:w-1/2 ${infoClasses}`}>
            {title && (
              <Typography
                variant="h3"
                className="uppercase md:text-2xl font-bold mb-2 lg:mb-6 text-primary"
              >
                {title}
              </Typography>
            )}

            {description && (
              <Box
                className="text-sm md:text-base [&>p]:mb-3 [&>ul]:list-disc [&>ul]:pl-4"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}

            {buttons && buttons.length > 0 && (
              <Box className="flex justify-start mt-2 lg:mt-6 gap-3">
                {buttons.map((button, index) => (
                  <Button
                    key={index}
                    href={button.link}
                    component={RouterLink}
                    variant={button.variant}
                    className={`min-w-[150px] md:min-w-[160px] px-2 md:px-4 text-sm ${
                      index === 1 ? '!text-black' : ''
                    } ${button.className}`}
                  >
                    {button.text}
                  </Button>
                ))}
              </Box>
            )}
          </Box>

          <Box className={`w-full lg:w-1/2 ${imageClasses}`}>
            <Image
              src={image?.url || ''}
              alt={image?.alt || ''}
              objectFit="contain"
              className="w-full rounded-xl"
              width={1200}
              height={360}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
